/**
 * #803 — dropping the cached threads a permanent delete killed.
 *
 * A thread whose messages were deleted for good can only answer 404 on its
 * next fetch, so its cache is removed rather than refetched. Removing EVERY
 * thread of the lane would also throw away threads that never held a
 * deleted message; this keeps those.
 */

/**
 * Remove the queries under `prefix` whose cached thread shows any of
 * `commIds` — directly or as a merged per-mailbox copy (`tag_comm_ids`).
 * `keep(query)` spares a query the caller must not remove, e.g. one a mounted
 * reader is still observing.
 */
export function removeThreadsContaining(queryClient, prefix, commIds, { keep } = {}) {
    const ids = new Set((commIds || []).filter(Boolean));
    if (!ids.size) return;
    queryClient.removeQueries({
        queryKey: prefix,
        predicate: (query) => !(keep && keep(query)) && threadShowsAny(query?.state?.data, ids),
    });
}

/** Whether a cached thread response (`{ data: [message, …] }`) shows an id. */
export function threadShowsAny(thread, ids) {
    const messages = Array.isArray(thread?.data) ? thread.data : [];
    return messages.some((m) => ids.has(m?.comm_id)
        || (Array.isArray(m?.tag_comm_ids) && m.tag_comm_ids.some((c) => ids.has(c))));
}
